import script from "./JaStreamGroupWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./JaStreamGroupWrapper.vue?vue&type=script&setup=true&lang=js"

import "./JaStreamGroupWrapper.vue?vue&type=style&index=0&id=c52f66f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c52f66f4"]])

export default __exports__